'use client';

import { StaticErrorContent } from '@packages/modules/src/StaticErrorContent/StaticErrorContent.client';
import { useIntl } from 'react-intl';
import { PageMetaData } from '@packages/modules/src/PageMetaData/PageMetaData';
import { PrudsysHomepageProductsRecoSlider } from '@packages/recommendations/src/components/ProductsRecoSliders/PrudsysHomepageProductsRecoSlider/PrudsysHomepageProductsRecoSlider.client';

export const NotFoundContent = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <PageMetaData page={{ type: 'error404', template: 'error404' }} />
      <StaticErrorContent
        title={formatMessage({
          id: 'page.404.title',
          defaultMessage: 'Entschuldigung, diese Seite ist leider nicht verfügbar.',
        })}
        description={formatMessage({
          id: 'page.404.description',
          defaultMessage: 'Die von dir gesuchte Seite existiert nicht mehr oder wurde verschoben.',
        })}
        description2={formatMessage({
          id: 'page.404.description2',
          defaultMessage: 'Schau dich gerne in unserem Sortiment um.',
        })}
        buttonLabel={formatMessage({
          id: 'page.404.button.label',
          defaultMessage: 'zur Startseite',
        })}
      />
      <PrudsysHomepageProductsRecoSlider
        elementIndex={0}
        pageTemplate="error"
        title={formatMessage({
          id: 'page.404.reco.title',
          defaultMessage: 'Unsere Topseller für dich',
        })}
      />
    </>
  );
};
